<template>
    <div class="campaign-page">
        <header-component :show_login_button="!isAuthenticated" :hide_points_msg="true"></header-component>

        <component :is="innerWelcomeBannerComponent"></component>

        <div v-if="show_page_load_error" style="margin-top: 2rem;padding:2rem;text-align:center;color:red"> Failed to load offer details. Please try again later. </div>

        <div class="shadow bg-white flexbox-container" v-if="mainOffer && mainOffer.OfferId">

            <div class="flexbox-item flexbox-item-1">
                <img v-if="mainOffer.MerchantImageURL" class="logo_max_width" :src="mainOffer.MerchantImageURL"/>
            </div>

            <div class="flexbox-item flexbox-item-2">
                <div class="space_below">
                    <div class="title" v-if="mainOffer.Merchant && mainOffer.Merchant.Name"> {{ mainOffer.Merchant.Name }} </div>
                    <div class="cashback" v-if="mainOffer.Headline"> {{ mainOffer.Headline }} </div>
                </div>
                <div>
                    <div class="redeem"> REDEEM </div>
                    <div class="rememptionType" v-if="mainOffer.RedemptionType">{{ mainOffer.RedemptionType }} </div>
                </div>
            </div>

            <div class="flexbox-item flexbox-item-3">
                <div class="space_below">
                    <a v-if="canActivate" @click="onActivateClick" :disabled="activating" :class="(activating) ? 'button pink midsize mid me-3 isDisabled' : 'button pink midsize mid me-3'">{{ activating ? 'Activating' : activateLabel }}</a>
                    <a v-if="activatedNow" href="javascript:" class="button activated pink midsize mid me-3">Activated</a>
                </div>
                <div>
                    <div class="redeem"> EXPIRES </div>
                    <div class="rememptionType" v-if="mainOffer.EventEndDate && isNaN(mainOffer.EventEndDate)">{{ formattedEndDate }} </div>
                </div>
            </div>
        </div>

        <div class="activation_notice" v-if="activation_notice"> {{ activation_notice }}</div>
        <div class="error_msg_with_offer" v-if="show_offer_activation_failed_msg"> {{ show_offer_activation_failed_msg }}</div>
        <div class="error_msg_with_offer" v-if="mainOffer && mainOffer.expired" style="color:#333"> This offer is no longer available. </div>

        <div v-if="mainOffer && mainOffer.LongDescription" class="copy-area">
            <h4>Offers details</h4>
            <div><p>{{ mainOffer.LongDescription }}</p></div>
        </div>
        <div v-if="mainOffer && (mainOffer.DetailedTerms || mainOffer.LongTerms)" class="copy-area">
            <h4>TERMS &amp; CONDITIONS</h4>
            <div>
                <p v-if="mainOffer.DetailedTerms">{{ mainOffer.DetailedTerms }}</p>
                <p v-if="mainOffer.LongTerms">{{ mainOffer.LongTerms }}</p>
            </div>
        </div>
        <div v-if="mainOffer && mainOffer.OfferId" class="copy-area">
            <a v-if="canActivate" @click="onActivateClick" :disabled="activating" :class="(activating) ? 'button pink midsize mid me-3 isDisabled' : 'button pink midsize mid me-3'">{{ activating ? 'Activating' : activateLabel }}</a>
            <a v-if="activatedNow" href="javascript:" class="button activated pink midsize mid me-3">Activated</a>
        </div>

        <!-- Register / Login modal — a self-contained Vue overlay (no jQuery/colorbox
             so Vue keeps full control of the DOM). The forms and their submit logic are
             reused from the shared Register/SignIn components. -->
        <div v-if="showModal" class="campaign-modal-overlay" @click.self="closeModal">
            <div class="campaign-modal-panel" :style="{ width: modalWidth, maxWidth: mode === 'addcard' ? '620px' : modalMaxWidth }">
                <button type="button" class="campaign-modal-close" @click="closeModal" aria-label="Close">&times;</button>
                <div class="campaign-modal-body">

                    <!-- Add-card view (Case 0: not enrolled, or Case 1: invalid card) -->
                    <div v-if="mode === 'addcard'" class="campaign-addcard">
                        <h4 class="campaign-modal-title">Add your card to activate</h4>
                        <p class="campaign-modal-sub" v-if="addCardNotice">{{ addCardNotice }}</p>
                        <div v-if="addCardError" class="campaign-modal-error">{{ addCardError }}</div>

                        <div class="form-container">
                            <div class="form-element">
                                <label class="title">Ulta Beauty Rewards<sup>&reg;</sup> Mastercard<sup>&reg;</sup> Credit Card number</label>
                                <input type="text" v-model="card_no" maxlength="16" @input="card_no = card_no.replace(/[^0-9]/g, '')">
                            </div>
                            <div class="form-element custom-checkbox">
                                <input id="campaign_addcard_terms" type="checkbox" class="styled-checkbox" v-model="cardTerms">
                                <label for="campaign_addcard_terms">By checking this box and entering my payment card information, I authorize my Payment Card Network (Mastercard<sup>&reg;</sup>) to monitor and share transaction data associated with my registered payment card (including spending history) with Ulta Beauty Rewards and its third party service providers in accordance with the Program Terms &amp; Conditions and Privacy Policy.</label>
                            </div>
                            <div class="form-element custom-checkbox">
                                <input id="campaign_addcard_optin" type="checkbox" class="styled-checkbox" v-model="cardEmailOptin">
                                <label for="campaign_addcard_optin">Yes, please send me email offers &amp; promotions.</label>
                            </div>
                            <div class="campaign-actions">
                                <button type="button" :disabled="addCardSubmitting" class="button pink large wide" @click="submitCard">{{ addCardSubmitting ? 'Please wait' : 'Add card and Activate' }}</button>
                            </div>
                        </div>
                    </div>

                    <!-- Register / Sign-in views -->
                    <template v-else>
                        <p class="campaign-modal-notice" v-if="mode === 'register' && loginNotice">{{ loginNotice }}</p>

                        <register-component
                            v-if="mode === 'register'"
                            :embedded="true"
                            heading="Sign up &amp; activate your offer"
                            submit-label="Sign Up and Activate"
                            @registered="onAuthSuccess('register')"
                            @email-exists="onEmailExists"
                            @submit-start="loginNotice = ''"
                        ></register-component>

                        <sign-in-component
                            v-else
                            :embedded="true"
                            :initial-email="loginEmail"
                            heading="Sign in to activate your offer"
                            submit-label="Sign In and Activate"
                            @authenticated="onAuthSuccess('login')"
                        ></sign-in-component>

                        <p class="campaign-switch campaign-switch--left" v-if="mode === 'register'">
                            Already have an account? <a href="#" @click.prevent="switchMode('login')">Sign in</a>
                        </p>
                        <p class="campaign-switch campaign-switch--left" v-if="mode === 'login'">
                            <a href="/forgot_password" target="_blank" rel="noopener">Forgot Password?</a>
                            &nbsp;&middot;&nbsp;
                            Need an account? <a href="/register">Enroll Now</a>
                        </p>
                    </template>

                </div>
            </div>
        </div>

        <!-- Footer -->
        <div class="campaign-footer">
            <footer-component>
                <template v-slot:after-links v-if="showPromotionalBanner">
                    <post-login-disclosure />
                </template>
            </footer-component>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import InnerWelcomeBannerPromotionComponent from "../banners/InnerWelcomeBannerPromotionComponent.vue";
    import InnerWelcomeBannerComponent from "../banners/InnerWelcomeBannerComponent.vue";
    import PostLoginDisclosure from "../promotions/PostLoginDisclosure.vue";

    export default {
        name: "CampaignLandingComponent",
        components: { PostLoginDisclosure },
        data() {
            return {
                slug: this.$route.params.slug,
                // Whether anonymous visitors may create an account from this campaign.
                // Off by default (config-driven, per-slug); when false the modal is
                // sign-in only. Absent slug -> false, matching the global default-off.
                signupEnabled: (window.appGlobalData.campaignSignup || {})[this.$route.params.slug] === true,
                mainOffer: null,
                isAuthenticated: false,
                showModal: false,
                mode: 'register',
                // Prefilled into the sign-in view when the account already exists (Case 4).
                loginEmail: '',
                // Header notice shown on the register view (e.g. "account already exists").
                loginNotice: '',
                // Add-card view (Case 0: signed in but no enrolled card).
                card_no: '',
                cardTerms: false,
                cardEmailOptin: true,
                addCardNotice: '',
                addCardError: '',
                addCardSubmitting: false,
                // How the user authenticated for this activation ('register' | 'login' |
                // 'existing'), reported to analytics on the activate event.
                authMethod: null,
                activating: false,
                activatedNow: false,
                // Modal size — tweak here to make the popup bigger/smaller on the page.
                modalWidth: '90%',
                modalMaxWidth: '800px',
                show_offer_activation_failed_msg: false,
                // Positive/info notice shown on the page (e.g. "already activated").
                activation_notice: null,
                show_page_load_error: false,
                showPromotionalBanner: window.appGlobalData.showPromotionalBanner,
                innerWelcomeBannerComponent: window.appGlobalData.showPromotionalBanner ? InnerWelcomeBannerPromotionComponent : InnerWelcomeBannerComponent
            }
        },
        computed: {
            formattedEndDate() {
                return (this.mainOffer && this.mainOffer.EventEndDate) ? moment(this.mainOffer.EventEndDate).format('MM-DD-YYYY') : '';
            },
            canActivate() {
                return this.mainOffer && this.mainOffer.OfferId && !this.mainOffer.expired && !this.activatedNow;
            },
            activateLabel() {
                if (this.isAuthenticated) {
                    return 'Activate';
                }
                return this.signupEnabled ? 'Sign Up and Activate' : 'Sign In and Activate';
            }
        },
        methods: {
            // Push a Google Tag Manager dataLayer event for the campaign funnel.
            // GTM only loads in production, so this is a safe no-op elsewhere. Every
            // event carries the campaign slug / offer id / source for segmentation.
            track(event, params) {
                try {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push(Object.assign({
                        event: event,
                        // `campaign_slug` (not `campaign`) to avoid clashing with GA4's
                        // built-in traffic-source Campaign dimension. The slug is the
                        // campaign's unique, human-readable id/name (e.g. "valvoline").
                        campaign_slug: this.slug,
                        offer_id: this.mainOffer ? this.mainOffer.OfferId : null,
                        src: this.$route.query.src || null
                    }, params || {}));
                } catch (e) { /* analytics must never break the flow */ }
            },
            openModal() {
                // Start on register when sign-up is enabled, otherwise sign-in only.
                // v-if remounts the form fresh each open, clearing any previously typed
                // values / errors / reCAPTCHA.
                this.mode = this.signupEnabled ? 'register' : 'login';
                this.loginEmail = '';
                this.loginNotice = '';
                this.showModal = true;
                this.track(this.signupEnabled ? 'campaign_signup_start' : 'campaign_login_start');
            },
            closeModal() {
                this.showModal = false;
            },
            switchMode(mode) {
                // Never allow switching to register when sign-up is disabled (defensive;
                // the link isn't rendered in that case).
                if (mode === 'register' && !this.signupEnabled) {
                    return;
                }
                this.loginNotice = '';
                this.mode = mode;
            },
            promptAddCard() {
                // Message depends on how the user got here:
                //  - just registered -> account was created, card couldn't be used
                //  - signed in / already logged in -> no card linked to the account
                var notice = this.authMethod === 'register'
                    ? "Your account was created, but offer activation failed because your card details couldn't be verified. Please add a valid card."
                    : "There is no card linked to your account. Please add a card to activate the offer.";
                this.openAddCard(notice);
            },
            openAddCard(notice) {
                // Shown for Case 0 (no enrolled card) and Case 1 (invalid card). Submitting
                // enrolls/replaces the card and activates in one call.
                this.mode = 'addcard';
                this.addCardNotice = notice || '';
                this.addCardError = '';
                this.card_no = '';
                this.cardTerms = false;
                this.cardEmailOptin = true;
                this.showModal = true;
                this.track('campaign_add_card_start');
            },
            submitCard() {
                this.addCardError = '';
                if (!/^\d{16}$/.test(this.card_no)) {
                    this.addCardError = 'Please enter your 16-digit card number.';
                    return;
                }
                if (!this.cardTerms) {
                    this.addCardError = 'Please accept the terms to continue.';
                    return;
                }
                this.addCardSubmitting = true;
                axios.post(this.apiEndPoints.campaignEnrollAndActivate, {
                    slug: this.slug,
                    card_no: this.card_no,
                    termsConditions: this.cardTerms,
                    emailOptIn: this.cardEmailOptin
                }).then(response => {
                    const data = response.data || {};
                    switch (data.code) {
                        case 'activated':
                            if (data.offer && data.offer.RedemptionEndDate) {
                                this.mainOffer.EventEndDate = data.offer.RedemptionEndDate;
                            }
                            this.markActivated(false);
                            break;
                        case 'already_activated':
                            this.markActivated(true, data.message || 'This offer has already been activated on your account.');
                            break;
                        default:
                            // invalid_card / enrollment_failed / bin-validation ("not eligible") — stay on the form.
                            this.addCardError = data.message || "We couldn't add that card. Please check the details and try again.";
                    }
                }).catch(error => {
                    if (error.response && (error.response.status === 401 || error.response.status === 419)) {
                        location.reload();
                        return;
                    }
                    const data = (error.response && error.response.data) || {};
                    this.addCardError = data.message || 'Something went wrong. Please try again.';
                }).finally(() => {
                    this.addCardSubmitting = false;
                });
            },
            onEmailExists(email) {
                // Case 4: registration found an existing account. Show a campaign-specific
                // header notice (pointing at the modal's Sign in link) and prefill the
                // email. The notice clears on the next submit via the submit-start event.
                this.loginEmail = email || '';
                this.loginNotice = 'An account with this email already exists. Please use the Sign in link below to sign in.';
            },
            onActivateClick() {
                // Logged-in users activate directly; anonymous users see the register/login modal.
                if (this.isAuthenticated) {
                    this.activateCampaignOffer();
                } else {
                    this.openModal();
                }
            },
            onAuthSuccess(method) {
                // Fired by the embedded Register/SignIn components once the user is
                // authenticated server-side (account created + logged in, or signed in).
                // Close the modal and run activation on the page so that if activation
                // fails, the error is visible with the CTA available to retry — rather
                // than being hidden behind the still-open register modal.
                this.isAuthenticated = true;
                this.authMethod = method;
                this.showModal = false;
                this.track(method === 'login' ? 'campaign_login' : 'campaign_register', { method: method });
                this.activateCampaignOffer();
            },
            markActivated(alreadyActive, notice) {
                this.activatedNow = true;
                this.showModal = false;
                this.activation_notice = notice || null;
                this.track('campaign_activate', {
                    method: this.authMethod || 'existing',
                    already_active: !!alreadyActive
                });
            },
            markActivateFailed(message) {
                this.activation_notice = null;
                this.show_offer_activation_failed_msg = message;
                this.track('campaign_activate_failed', {
                    method: this.authMethod || 'existing',
                    reason: message
                });
            },
            activateCampaignOffer() {
                this.activating = true;
                this.show_offer_activation_failed_msg = false;
                this.activation_notice = null;
                axios.post(this.apiEndPoints.activateCampaignOffer, {
                    slug: this.slug
                }).then(response => {
                    // The backend returns a single `code` for every outcome (see
                    // SiteController::activateCampaignOffer). Branch on it.
                    const data = response.data || {};
                    switch (data.code) {
                        case 'activated':
                            if (data.offer && data.offer.RedemptionEndDate) {
                                this.mainOffer.EventEndDate = data.offer.RedemptionEndDate;
                            }
                            this.markActivated(false);
                            break;

                        case 'already_activated':
                            // Case 3: offer already redeemed on this account -> soft success.
                            this.markActivated(true, data.message || 'This offer has already been activated on your account.');
                            break;

                        case 'invalid_card':
                        case 'enrollment_needed':
                            // The card couldn't be used (bad/unverifiable or not enrolled).
                            // Prompt for a valid card; wording depends on whether the account
                            // was just created in this flow.
                            this.promptAddCard();
                            break;

                        default:
                            this.markActivateFailed(data.message || 'Offer activation failed. Please try again later.');
                    }
                }).catch(error => {
                    if (error.response && (error.response.status === 401 || error.response.status === 419)) {
                        location.reload();
                        return;
                    }
                    const data = (error.response && error.response.data) || {};
                    this.markActivateFailed(data.message || 'Offer activation failed. Please try again later.');
                }).finally(() => {
                    this.activating = false;
                });
            },
            loadOffer() {
                axios.get(this.apiEndPoints.getCampaignOffer, { params: { slug: this.slug } })
                    .then(response => {
                        if (response.data && response.data.OfferId) {
                            this.mainOffer = response.data;
                        } else {
                            this.show_page_load_error = true;
                        }
                    })
                    .catch(() => {
                        this.show_page_load_error = true;
                    });
            }
        },
        mounted() {
            this.track('campaign_view');
            this.loadOffer();

            // Detect an already-authenticated visitor so we can offer one-click
            // activation and show the logged-in header instead of "Log in".
            axios.get('/get-user', {})
                .then(response => {
                    if (response.data && response.data.data && response.data.data.id) {
                        this.isAuthenticated = true;
                        this.resetUserInLocalStorage(response.data.data);
                    }
                })
                .catch(() => { this.isAuthenticated = false; });
        }
    }
</script>

<style scoped>
    .campaign-page {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
    }
    .campaign-footer {
        margin-top: auto;
    }

    .campaign-modal-overlay {
        position: fixed;
        top: 0; left: 0; right: 0; bottom: 0;
        z-index: 10000;
        background: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding: 4vh 2rem;
        overflow-y: auto;
    }
    .campaign-modal-panel {
        position: relative;
        background: #ffffff;
        border-radius: 1rem;
        width: 90%;
        max-width: 1100px;
        margin: auto;
        padding: 2rem 3rem 3rem;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    }
    .campaign-modal-close {
        position: absolute;
        top: 1rem;
        right: 1.5rem;
        background: none;
        border: 0;
        font-size: 3.4rem;
        line-height: 1;
        color: #f26b1c;
        cursor: pointer;
        z-index: 1;
    }

    .campaign-modal-body { padding: 1rem 0; }
    /* Shared pattern for the modal message lines: small, italic, left-aligned. */
    .campaign-modal-notice,
    .campaign-modal-error,
    .campaign-modal-sub {
        text-align: left;
        font-size: 1.3rem;
        font-style: italic;
        line-height: 1.4;
        margin: 0 0 1.5rem;
    }
    .campaign-modal-notice { color: #b00050; }
    .campaign-modal-error { color: #d0021b; }
    .campaign-modal-sub { color: #555555; }
    .campaign-switch { text-align: center; font-size: 1.4rem; margin-top: 1.5rem; }
    .campaign-switch--left { text-align: left; }
    .campaign-switch a { color: #e00087; text-decoration: underline; }

    /* Normalize the embedded Register/SignIn page forms for the modal:
       the page grid uses viewport (vw) sizing that renders oversized/cramped inside
       the popup. These overrides are scoped to the modal only (the standalone
       /register and /sign_in pages keep their original styling). */
    .campaign-modal-body ::v-deep .account-form { padding: 0; }
    .campaign-modal-body ::v-deep .heading { margin-bottom: 1.5rem; }
    .campaign-modal-body ::v-deep .account-form h4 { font-size: 2.4rem; margin-bottom: 0.8rem; }
    .campaign-modal-body ::v-deep .account-form p { font-size: 1.4rem; line-height: 1.4; }
    .campaign-modal-body ::v-deep .form-element { margin-bottom: 1.8rem; }
    .campaign-modal-body ::v-deep .form-element label.title { font-size: 1.4rem; padding: 0.3rem 0; }
    .campaign-modal-body ::v-deep .form-element input[type="text"],
    .campaign-modal-body ::v-deep .form-element input[type="email"],
    .campaign-modal-body ::v-deep .form-element input[type="password"] { font-size: 1.5rem; padding: 1rem 1.2rem; }
    .campaign-modal-body ::v-deep .form-element > span { font-size: 1.2rem; }
    /* the lone card-number field should span the full row instead of floating at 48% */
    .campaign-modal-body ::v-deep .clear > .form-element.float-left:only-child { width: 100%; float: none; }
    /* checkbox label text should match the other form text sizes (page default is vw-based) */
    .campaign-modal-body ::v-deep .styled-checkbox + label { font-size: 1.4rem; line-height: 1.4; }
    /* the sign-in form is constrained to a 50% bootstrap column on the page; use full width in the modal */
    .campaign-modal-body ::v-deep .m-page-container .col-md-6 { flex: 0 0 100%; max-width: 100%; }
    .campaign-modal-body ::v-deep .m-page-container .offset-md-3 { margin-left: 0; }
    /* Full-width form containers so the fields line up with the left-aligned links below. */
    .campaign-modal-body ::v-deep .page-container,
    .campaign-modal-body ::v-deep .m-page-container { width: 100%; }

    /* Landing-page CTA button: center the label text + interactive hover
       (the anchor has no href, so it needs an explicit pointer cursor) */
    .flexbox-item-3 a.button,
    .copy-area a.button { text-align: center; cursor: pointer; transition: background-color 0.2s ease, opacity 0.2s ease; }
    .flexbox-item-3 a.button:hover,
    .copy-area a.button:hover { opacity: 0.9; }

    .error_msg_with_offer {
        display: flex; justify-content: center; color: red; margin-top: -2rem; margin-bottom: 2rem; font-size: 2rem;
    }
    .activation_notice {
        display: flex; justify-content: center; text-align: center; color: #2e7d32; margin-top: -2rem; margin-bottom: 2rem; font-size: 1.8rem;
    }
    .flexbox-container {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin: -2rem auto 6rem;
        width: 50%;
        border-radius: 1.4rem;
        padding: 3rem;
    }
    .flexbox-item { padding: 2rem; }
    .title { font-size: 1.5rem; color: #333333; margin-bottom: 0.5rem; }
    .redeem { font-size: 1.2rem; color: #333333; margin-bottom: 0.5rem; }
    .logo_max_width { max-width: 230px; }
    .cashback { font-size: 2.5rem; color: black; }
    .rememptionType { font-size: 2rem; color: black; }
    .space_below { margin-bottom: 1.5rem; }
    .copy-area { width: 70%; margin-left: 15%; padding: 1.5rem 0; }
    .isDisabled { pointer-events: none; }
    p { font-size: 2rem; margin-bottom: 1rem; line-height: 1.3; }
    h4 { font-size: 2.4rem; margin-bottom: 1rem; }

    @media screen and (max-width: 700px) {
        .flexbox-container {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            margin: -2rem auto 6rem;
            width: 90%;
            border-radius: 1.4rem;
            padding: 3rem;
        }
        .copy-area a {
            display: flex;
            justify-content: center;
        }
    }
</style>
